import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicSecureDataShareReadParamsRawI,
	LWApiPublicSecureDataShareReadResultRawI,
} from '@liquidweb-dev/club-sauce/public/secureDataShare/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { actions as accountDetailsActions } from 'modules/api/account/detailsModule';
import api from 'modules/queries/api';
import { ACCOUNT_DETAILS_QUERY_KEY } from 'modules/queries/account/useDetails';
import { useDispatch } from 'react-redux';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useSecureDataShareRead = () => {
	const snackbarError = useSnackbarError();
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicSecureDataShareReadResultRawI,
		ApiErrorI,
		LWApiPublicSecureDataShareReadParamsRawI
	>({
		mutationFn: (params) => api.secureDataShare.apiRaw.read(params),
		onError: snackbarError,

		// Note - we do not want to invalidate `/secureDataShare/list` upon read as that will cause secure notes with only one view remaining to be removed from the list. Only invalidate `/secureDataShare/list` once the user has confirmed they have viewed the note.

		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: [
					ACCOUNT_DETAILS_QUERY_KEY,
					{
						alsowith: [
							'managementPortal',
							'businessUnit',
							'customerLifecycle',
							'highlights',
							'referAFriend',
						],
					},
				],
			});

			// TODO DEV-3707 - remove once we no longer fetch account/details with redux api pattern
			dispatch(
				accountDetailsActions.invalidate({
					alsowith: [
						'managementPortal',
						'businessUnit',
						'customerLifecycle',
						'highlights',
						'referAFriend',
					],
				}),
			);
		},
	});
};

export default useSecureDataShareRead;
